export enum Environment {
  TESTING = 'testing',
  DEVELOPMENT = 'development',
  STAGE = 'stage',
  LIVE = 'live',
}
